import { ref } from 'vue'

// Bridges the service-worker update lifecycle (driven from main.js, outside any
// Vue component) to the UI. `main.js` calls `notifyPwaUpdateReady()` when
// vite-plugin-pwa (prompt mode) reports a new build waiting, and registers the
// `updateServiceWorker` handler via `setPwaUpdateHandler()`. `PwaUpdatePrompt.vue`
// reads `needRefresh` and calls `applyUpdate()` when the user clicks Reload.

const needRefresh = ref(false)
let updateHandler = null

// Called by main.js with the `updateServiceWorker` fn returned by registerSW.
export function setPwaUpdateHandler(handler) {
  updateHandler = handler
}

// Called by main.js from registerSW's onNeedRefresh — a new SW is waiting.
export function notifyPwaUpdateReady() {
  needRefresh.value = true
}

// Test helper: reset module singleton state between cases.
export function resetPwaUpdateState() {
  needRefresh.value = false
  updateHandler = null
}

export function usePwaUpdate() {
  // In prompt mode `updateHandler(true)` messages skipWaiting; the SW's
  // `controlling` event then performs the single clean reload. If the handler
  // isn't wired yet (shouldn't happen in prod), hard-reload so the user still
  // lands on the new build.
  const applyUpdate = async () => {
    if (typeof updateHandler === 'function') {
      await updateHandler(true)
    } else if (typeof window !== 'undefined' && window.location) {
      window.location.reload()
    }
  }

  const dismiss = () => {
    needRefresh.value = false
  }

  return { needRefresh, applyUpdate, dismiss }
}
